import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useState } from 'react';
import axios from 'axios';

export default function FileSelectDialog(props) {

  const [pdfTimestamp, setPdfTimestamp] = useState(null);
  const [xmlTimestamp, setXmlTimestamp] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  const PdfSelected = (timestamp) => {
    return timestamp === pdfTimestamp; 
  };

  const XmlSelected = (timestamp) => {
    return timestamp === xmlTimestamp; 
  };

  const UpdateApproved = async () => {
    var response = axios.get('/updateApproved', { params: { pOrderID: props.orderID, pTimestamps: pdfTimestamp + "," + (xmlTimestamp || '') } });
    try {
      var resultData = (await response).data;
      if(resultData && resultData === "Success")
        props.onConfirm(pdfTimestamp);
      else
        setErrorMsg("System Error - Failed to Approve Files");
    }
    catch { setErrorMsg("System Error - Failed to Approve Files"); }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description" 
    >
      <DialogTitle id="alert-dialog-title">
        <span style={{color:'#12335e'}}>Select a PDF and XML File to Confirm and Submit to Lender</span>
      </DialogTitle>
      <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <table style={{width:'100%'}}>
              <tbody>
                <tr>
                  <td style={{borderRight: '1px solid lightgray', width: '500px', verticalAlign: 'top'}}>
                    <div style={{textAlign:'center', fontWeight:'bold', color:'#747f8c'}}>PDF</div>
                    {props.listItems && (props.listItems
                      .filter((fileItem) => fileItem && fileItem.name && fileItem.name.toLowerCase().includes(".pdf"))
                      .map((fileItem) => (
                        <div key={fileItem.timestamp}>
                          <input
                            type="radio"
                            id={fileItem.timestamp}
                            checked={PdfSelected(fileItem.timestamp)}
                            onChange={() => void 0}
                            onClick={() => {setPdfTimestamp(fileItem.timestamp)}}
                          />
                          <label htmlFor={fileItem.timestamp}>
                            <Tooltip placement="right" title={<span>{fileItem.timestamp} {fileItem.approved === 'True' && (<span><br/>[File Previously Submitted]</span>)}</span>}>
                              <span style={{color: fileItem.approved === 'True' ? '#1c6910' : '#50544f'}}>{fileItem.name}</span>
                            </Tooltip>
                          </label>
                        </div>
                      )
                    ))}
                  </td>
                  <td style={{width: '500px', paddingLeft:'10px', verticalAlign: 'top'}}>
                    <div style={{textAlign:'center', fontWeight:'bold', color:'#747f8c'}}>XML</div>
                    {props.listItems && (props.listItems
                      .filter((fileItem) => fileItem && fileItem.name && fileItem.name.toLowerCase().includes(".xml"))
                      .map((fileItem) => (
                        <div key={fileItem.timestamp}>
                          <input
                            type="radio"
                            id={fileItem.timestamp}
                            checked={XmlSelected(fileItem.timestamp)}
                            onChange={() => void 0}
                            onClick={() => {setXmlTimestamp(fileItem.timestamp)}}
                          />
                          <label htmlFor={fileItem.timestamp}>
                            <Tooltip placement="right" title={<span>{fileItem.timestamp} {fileItem.approved === 'True' && (<span><br/>[File Previously Submitted]</span>)}</span>}>
                              <span style={{color: fileItem.approved === 'True' ? '#1c6910' : '#50544f'}}>{fileItem.name}</span>
                            </Tooltip>
                          </label>
                        </div>
                      )
                    ))}
                  </td>
                </tr>
              </tbody>
            </table>
            {errorMsg && (
              <Alert severity="error" sx={{ mb: 2, width: '100%' }}>
                {errorMsg}
              </Alert>
            )}
          </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{ maxWidth: '1000px', mx: 'auto', border: 0, borderRadius: 2, borderColor: 'grey.400', p: 2 }}>
          <div style={{textAlign:'center'}}>
            <Button variant="contained" size="small" style={{marginRight:'5px'}}
              disabled={!pdfTimestamp}
              onClick={()=>UpdateApproved()}>
              Submit
            </Button>
            <Button variant="outlined" size="small" autoFocus onClick={props.onClose}>
              Cancel
            </Button>
          </div>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
